import { render, staticRenderFns } from "./nodeInfoDisplayer.vue?vue&type=template&id=ff4afe60&scoped=true&"
import script from "./nodeInfoDisplayer.vue?vue&type=script&lang=js&"
export * from "./nodeInfoDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./nodeInfoDisplayer.vue?vue&type=style&index=0&id=ff4afe60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4afe60",
  null
  
)

component.options.__file = "nodeInfoDisplayer.vue"
export default component.exports